import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'home-fitness-workshop-list',
  templateUrl: './home-fitness-workshop-list.component.html',
  styleUrls: ['./home-fitness-workshop-list.component.scss']
})
export class HomeFitnessWorkshopListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
